/* db-tier-promo.js (Daily Bloom, ADR-0002 db- prefix)
 * Live refresh for the PDP tier-promo bar (snippets/db-tier-promo.liquid).
 * The bar is server-rendered Liquid, single-source with the cart drawer per
 * ADR-0006, so instead of duplicating tier math client-side we re-fetch the
 * enclosing section via the Section Rendering API after every cart mutation
 * and swap the promo node in place.
 *
 * Events: the theme's internal bus fires 'cart:item-added' for adds and
 * 'line-item:change:end' for quantity updates and removals (the same hooks
 * the standard-events adapter in app.js subscribes to), so quick-add, the
 * drawer's plus/minus, and line removal all land here.
 */
(function () {
  'use strict';

  // Theme editor: a ?section_id= request is served from the PUBLISHED theme,
  // not the unsaved preview, so a swap there would revert the merchant's
  // in-progress edits (and section re-loads would stack duplicate listeners).
  // Same guard as the other section-API assets (slideshow, collection-tabs).
  if (window.Shopify && window.Shopify.designMode) return;

  var SELECTOR = '[data-db-tier-promo]';
  var inFlight = false;
  var queued = false;

  function refresh() {
    var el = document.querySelector(SELECTOR);
    if (!el) return;
    if (inFlight) {
      queued = true;
      return;
    }
    inFlight = true;

    var sectionId = el.getAttribute('data-section-id');
    // Keep the page's own query string (preview_theme_id on draft previews,
    // variant, etc.) so the section render always resolves to the same theme
    // and context as the page the shopper is looking at.
    var search = window.location.search;
    var url = window.location.pathname + search + (search ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SELECTOR);
        var current = document.querySelector(SELECTOR);
        // fresh can be legitimately absent only if the render gates flipped
        // mid-session (kill switch, metafield); keep the current node then
        // rather than risk nuking the bar on a transient parse oddity.
        if (fresh && current) current.replaceWith(fresh);
      })
      .catch(function (err) {
        // Visual-only surface: keep the stale bar rather than break the PDP,
        // but say why so a broken refresh is diagnosable.
        console.warn('db-tier-promo: refresh skipped (' + err.message + '); bar may be stale until reload');
      })
      .then(function () {
        inFlight = false;
        if (queued) {
          queued = false;
          refresh();
        }
      });
  }

  document.addEventListener('cart:item-added', refresh);
  document.addEventListener('line-item:change:end', refresh);
  // Post-login cart identity relink (snippets/db-cart-identity-relink.liquid)
  // re-evaluates segment discounts server-side and announces itself with
  // cart:refresh; the ladder is audience-gated, so re-render then too.
  document.addEventListener('cart:refresh', refresh);
})();
